import { Package } from "../package";

export class PackageProduct {
    productId?:number;
    packageObject?:Package;
}
